// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> dietz-property-group-prestige -> sycamore-creek-apartments
// Generated: 2026-09-23T21:49:16.841Z
// Counts: 1 design, 11 content, 2 slot group, 2 collection binding, 7 section, 1 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "adtaxi-tracking.profile": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_adtaxi_domain"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore affordable two- and three-bedroom apartment floor plans at Sycamore Creek in Sidney, OH. Our LIHTC affordable housing community offers project-based Section 8 apartment homes for qualifying households.</p><p>Income limits range from 50% to 60% of the Area Median Income (AMI), depending on the apartment home. Housing Choice Vouchers are accepted. Contact our leasing team for current availability and qualification information. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Affordable 2 &amp; 3 Bedroom Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Sycamore Creek, offering spacious two- and three-bedroom affordable apartments in Sidney, OH. Enjoy thoughtfully designed homes with fully equipped kitchens and private patios, plus convenient community amenities including a business center and playground.</p><p>Sycamore Creek participates in the Low-Income Housing Tax Credit (LIHTC) program and offers project-based Section 8 apartment homes. Income limits range from 50% to 60% of the Area Median Income (AMI), depending on the apartment home. Housing Choice Vouchers are accepted.</p><p>Explore our affordable apartments in Sidney, OH, and contact our leasing team to learn more about current availability and income qualifications.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "communityamenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "custom_b919270d-cb11-4dc3-8480-4619655f44ef",
      "custom_0cfa069b-02a5-4e7c-886e-9ef54adc09e1",
      "custom_7f9666e3-4ab7-4d1b-8133-d640ce4aa39f"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1,
      7,
      11
    ],
    "ordering": null,
    "customItems": null
  },
  "interioramenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "custom_a226250a-eeb1-480a-95e1-f9de4ef508d6",
      "custom_c13af810-e25f-46f4-9fd6-f7289ce9c3d6",
      "custom_fb84a9a2-b2e1-4a0c-b604-f805ce3933f8",
      "custom_7fed309b-71b9-4150-8e8a-d2245c3b4a83",
      "custom_e230da59-8776-4f89-99f5-e3f7394fb427",
      "custom_df96ebba-9a7b-4c2b-a87c-32facc94cf14",
      "custom_9ae778eb-fd6e-49af-a380-38d8b38956af",
      "custom_7c96e6d0-a44e-43c1-8ad4-3b022b94b2d7",
      "custom_28df7bbc-8ca8-4dbd-a875-beb896857ee9"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      2,
      4,
      5,
      10,
      14,
      7,
      15,
      16,
      18
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "adtaxi-tracking",
      "blockId": "adtaxi-tracking",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "realpage-calendar",
      "blockId": "realpage-calendar",
      "position": 0
    }
  ]
};

export const styleOverrides = {
  "_section.InstagramSection": {
    "properties": {
      "display": "none"
    }
  }
};
